import { createRouter, createWebHashHistory } from "vue-router";
import QuizApp from "../QuizApp.vue";

export const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        { path: "/feedback/:id", name: "feedback", component: QuizApp },

        { path: "/welcome", name: "welcome", component: QuizApp },
        // Deep-link alias: lands on the welcome view without the intro reveal
        { path: "/start", name: "start", redirect: { name: "welcome" } },

        { path: "/:id-intro", name: "questionIntro", component: QuizApp },
        { path: "/:id", name: "question", component: QuizApp },
        { path: "/score", name: "score", component: QuizApp },

        { path: "/:catchAll(.*)", name: "catchAll", component: QuizApp },
    ],
});
